import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import axios from 'axios'
import i18n from 'i18next'
import React, {useEffect, useState} from 'react'
import {ChevronDown} from '../Icons/index.jsx'
import {
  clearCurrentUserToken,
  clearNewUserInfo,
  clearProjectInfo,
} from '../Services/storage.jsx'
import { getApiUrl } from '../Services/helpers.jsx'

const onSignOut = () => {
  clearCurrentUserToken()
  clearNewUserInfo()
  clearProjectInfo()
  // Svuota subito il contenitore del menu utente
  const userInfoDomElement = document.getElementById('userInfo')
  if (userInfoDomElement) {
    userInfoDomElement.innerHTML = ''
  }
  window.dispatchEvent(new CustomEvent('user-logout'))
  window.location.reload()
}

export function UserMenu({user: {email, name}}) {
  const [link, setLink] = useState(null)
  const firstName = name !== null && name.length > 0 ? name.split(' ')[0] : ''
  const initial = (firstName[0] || email[0]).toUpperCase()

  useEffect(() => {
    axios
      .get(getApiUrl() + '/customer/otsAuthLink')
      .then((response) => {
        setLink(response.data)
      })
      .catch((error) => {
        console.error('Error fetching auth link:', error);
      })
  }, [])

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <div className={'user'} tabIndex={0}>
          <div className={'user__icon'}>
            <span className={'user__initial'}>{initial}</span>
          </div>
          <ChevronDown className={'user__chevron-down'} />
        </div>
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal asChild>
        <div className="user-menu">
          <DropdownMenu.Content sideOffset={10} className="user-menu__popover">
            <DropdownMenu.Arrow style={{fill: 'white', stroke: '#abb3bd'}} />
            <div className="user__greeting">
              {i18n.t('Components.User.greeting', {
                name: firstName || email,
              })}
            </div>
            {link && (
              <DropdownMenu.Item asChild className="user-menu__item">
                <a
                  data-sign-in={'customer'}
                  className={'user__link'}
                  href={link}
                  target={'_blank'}
                  rel="noreferrer"
                >
                  {i18n.t('Components.User.yourOrdersLabel')}
                </a>
              </DropdownMenu.Item>
            )}
            <DropdownMenu.Item asChild className="user-menu__item">
              <div className={'user__link'} onClick={onSignOut}>
                {i18n.t('Components.User.signoutLabel')}
              </div>
            </DropdownMenu.Item>
          </DropdownMenu.Content>
        </div>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  )
}
